import ApiService from "@/modules/api/api.service";

import ObjectBuilderInterface from "../api/object-builder.interface";
import { FileProcessingImageType } from "./file-processing-image-type";
import Item from "./item.model";

export default class FileProcessingRepository {
  constructor(
    private api: ApiService,
    private objectBuilder: ObjectBuilderInterface<Item>
  ) {}

  public async multiPageFileUpload(
    file: File,
    imageType: Exclude<
      FileProcessingImageType,
      FileProcessingImageType.QaVideo | FileProcessingImageType.QaVideoThumb
    >,
    product?: string,
    onUploadProgress?: (progressEvent: ProgressEvent) => void
  ): Promise<Item[]> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("imageType", imageType.toString());

    if (product) {
      formData.append("product", product);
    }

    const result = await this.api.post(
      "multi_page_file_upload_jobs",
      formData,
      onUploadProgress
    );

    const items = result?.data?.items;

    if (!Array.isArray(items)) {
      return [];
    }

    return items.map((item) => this.objectBuilder.buildFromJSON(item));
  }

  public async uploadFile(
    file: File,
    imageType: Exclude<
      FileProcessingImageType,
      FileProcessingImageType.QaVideo | FileProcessingImageType.QaVideoThumb
    >,
    product?: string,
    onUploadProgress?: (progressEvent: ProgressEvent) => void
  ): Promise<Item> {
    const formData = new FormData();
    formData.append("file", file, file.name);

    formData.append("imageType", imageType.toString());

    if (product) {
      formData.append("product", product);
    }

    const result = await this.api.post(
      "file_upload_jobs",
      formData,
      onUploadProgress
    );

    return this.objectBuilder.buildFromJSON(result.data["item"]);
  }

  public async uploadVideoFile(
    file: File,
    product?: string,
    onUploadProgress?: (progressEvent: ProgressEvent) => void
  ): Promise<{
    item: Item;
    itemThumb: Item;
  }> {
    const formData = new FormData();

    formData.append("file", file, file.name);
    formData.append("imageType", FileProcessingImageType.QaVideo.toString());

    if (product) {
      formData.append("product", product);
    }

    const result = await this.api.post(
      "file_upload_jobs",
      formData,
      onUploadProgress
    );

    return {
      item: this.objectBuilder.buildFromJSON(result.data.item),
      itemThumb: this.objectBuilder.buildFromJSON(result.data.item_thumb),
    };
  }
}
